import { css } from '@emotion/core'
import theme from 'Theme'
const { typography, colors, spacing } = theme

export default () => css`
  .progress__label {
    font-size: ${typography.sizes.small};
    text-align: center;
    margin-bottom: ${spacing.base_1}px;
  }

  progress {
    display: block;
    width: 200px;
    height: 3px;
    appearance: none;
    border: none;
    background-color: ${colors.progress.backgroundColor};
    color: ${colors.progress.backgroundColor};

    &::-webkit-progress-bar {
      background-color: ${colors.progress.backgroundColor};
    }
    &::-webkit-progress-value {
      background-color: ${colors.progress.color};
    }
    &::-moz-progress-bar {
      background-color: ${colors.progress.color};
    }
  }
`
